<template>
  <svg
    viewBox="0 0 120 120"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
    class="size-full"
  >
    <!-- Background blob -->
    <ellipse
      cx="60"
      cy="62"
      rx="52"
      ry="46"
      fill="currentColor"
      opacity="0.04"
      stroke="none"
    />

    <!-- Road surface -->
    <path
      d="M6 78 Q30 74 60 76 Q90 78 114 74"
      fill="currentColor"
      opacity="0.05"
      stroke="none"
    />
    <path
      d="M6 78 Q30 74 60 76 Q90 78 114 74"
      opacity="0.15"
      stroke-width="1"
    />

    <!-- Road dashes -->
    <line
      x1="22"
      y1="76"
      x2="30"
      y2="75.5"
      opacity="0.12"
      stroke-width="1.5"
    />
    <line
      x1="48"
      y1="75.5"
      x2="56"
      y2="76"
      opacity="0.12"
      stroke-width="1.5"
    />
    <line
      x1="74"
      y1="77"
      x2="82"
      y2="76.5"
      opacity="0.12"
      stroke-width="1.5"
    />

    <!-- Background tree — left -->
    <line
      x1="20"
      y1="56"
      x2="20"
      y2="68"
      opacity="0.08"
      stroke-width="1.5"
    />
    <circle
      cx="20"
      cy="52"
      r="6"
      fill="currentColor"
      opacity="0.06"
      stroke="none"
    />
    <circle
      cx="20"
      cy="52"
      r="6"
      opacity="0.1"
      stroke-width="1"
    />
    <circle
      cx="16"
      cy="55"
      r="4"
      fill="currentColor"
      opacity="0.04"
      stroke="none"
    />
    <circle
      cx="16"
      cy="55"
      r="4"
      opacity="0.07"
      stroke-width="1"
    />

    <!-- Background tree — right -->
    <line
      x1="100"
      y1="58"
      x2="100"
      y2="66"
      opacity="0.08"
      stroke-width="1.5"
    />
    <circle
      cx="100"
      cy="54"
      r="5"
      fill="currentColor"
      opacity="0.05"
      stroke="none"
    />
    <circle
      cx="100"
      cy="54"
      r="5"
      opacity="0.08"
      stroke-width="1"
    />
    <circle
      cx="104"
      cy="56"
      r="3.5"
      fill="currentColor"
      opacity="0.04"
      stroke="none"
    />
    <circle
      cx="104"
      cy="56"
      r="3.5"
      opacity="0.06"
      stroke-width="1"
    />

    <!-- Speed sign -->
    <line
      x1="94"
      y1="44"
      x2="94"
      y2="62"
      opacity="0.15"
      stroke-width="1.5"
    />
    <circle
      cx="94"
      cy="40"
      r="6"
      opacity="0.15"
      stroke-width="1.5"
    />
    <circle
      cx="94"
      cy="40"
      r="6"
      fill="currentColor"
      opacity="0.04"
      stroke="none"
    />
    <text
      x="94"
      y="42.5"
      text-anchor="middle"
      font-size="6"
      fill="currentColor"
      opacity="0.18"
      stroke="none"
      font-weight="700"
    >50</text>

    <!-- Car body — friendly rounded hatchback -->
    <path
      d="M30 68
         C30 64 31 61 34 59
         L38 54
         L44 44
         C46 41 49 39 53 38
         L67 38
         C71 38 74 40 76 43
         L82 52
         L86 54
         C89 56 91 59 91 62
         L91 68"
      stroke-width="2.5"
    />
    <path
      d="M30 68
         C30 64 31 61 34 59
         L38 54
         L44 44
         C46 41 49 39 53 38
         L67 38
         C71 38 74 40 76 43
         L82 52
         L86 54
         C89 56 91 59 91 62
         L91 68
         L30 68 Z"
      fill="currentColor"
      opacity="0.06"
      stroke="none"
    />

    <!-- Roof arc -->
    <path
      d="M46 44 L54 38 L69 38 L78 44"
      stroke-width="2"
    />

    <!-- Windshield glass -->
    <path
      d="M48 44 L56 39 L65 38.5 L65 44 Z"
      fill="currentColor"
      opacity="0.08"
    />

    <!-- Rear window -->
    <path
      d="M67 38.5 L72 39 L77 43 L69 44 Z"
      fill="currentColor"
      opacity="0.08"
    />

    <!-- Window divider -->
    <line
      x1="66"
      y1="38.5"
      x2="67"
      y2="44"
      stroke-width="1.5"
    />

    <!-- Beltline -->
    <line
      x1="38"
      y1="54"
      x2="82"
      y2="52"
      opacity="0.2"
      stroke-width="1"
    />

    <!-- Door line -->
    <line
      x1="60"
      y1="44"
      x2="60"
      y2="64"
      opacity="0.5"
      stroke-width="1"
    />

    <!-- Door handles -->
    <line
      x1="54"
      y1="53"
      x2="57"
      y2="53"
      opacity="0.3"
      stroke-width="1.5"
    />
    <line
      x1="65"
      y1="52.5"
      x2="68"
      y2="52.5"
      opacity="0.3"
      stroke-width="1.5"
    />

    <!-- Headlight -->
    <ellipse
      cx="89"
      cy="57"
      rx="2.5"
      ry="2"
      fill="currentColor"
      opacity="0.12"
      stroke-width="1"
    />

    <!-- Taillight -->
    <ellipse
      cx="32"
      cy="59"
      rx="2"
      ry="1.5"
      fill="currentColor"
      opacity="0.12"
      stroke-width="1"
    />

    <!-- Undercarriage with wheel arches -->
    <path
      d="M30 68
         L36 68
         C36 62 41 59 46 59
         C51 59 55 62 55 68
         L66 68
         C66 62 70 59 75 59
         C80 59 84 62 84 68
         L91 68"
      stroke-width="2"
    />

    <!-- Front wheel -->
    <circle
      cx="75"
      cy="68"
      r="7.5"
      stroke-width="2"
    />
    <circle
      cx="75"
      cy="68"
      r="4"
      stroke-width="1.5"
    />
    <circle
      cx="75"
      cy="68"
      r="1.5"
      fill="currentColor"
      opacity="0.3"
      stroke="none"
    />

    <!-- Rear wheel -->
    <circle
      cx="46"
      cy="68"
      r="7.5"
      stroke-width="2"
    />
    <circle
      cx="46"
      cy="68"
      r="4"
      stroke-width="1.5"
    />
    <circle
      cx="46"
      cy="68"
      r="1.5"
      fill="currentColor"
      opacity="0.3"
      stroke="none"
    />

    <!-- Ground shadow -->
    <ellipse
      cx="60"
      cy="78"
      rx="32"
      ry="2"
      fill="currentColor"
      opacity="0.06"
      stroke="none"
    />

    <!-- Exhaust puff -->
    <circle
      cx="26"
      cy="66"
      r="2.5"
      opacity="0.1"
      stroke-width="1"
    />
    <circle
      cx="21"
      cy="64"
      r="2"
      opacity="0.07"
      stroke-width="1"
    />
    <circle
      cx="17"
      cy="63"
      r="1.5"
      opacity="0.05"
      stroke-width="1"
    />
  </svg>
</template>
